import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import MenuButton from 'Common/MenuButton/MenuButton';
import MenuPage from 'Common/Navigation/MenuPage';
import useSupervisorAccess from '../../../../Common/Utils/Hooks/useSupervisorAccess';

const Menu = ({ onChange }) => {
	return (
		<>
			<MenuPage title="Release Management">
				<MenuButton
					title="Check Contract"
					icon={() => <FontAwesomeIcon icon={faChalkboardTeacher} size="9x" />}
					width="80%"
					onClick={useSupervisorAccess(onChange, 'check_contract')}
				/>
				<MenuButton
					title="Amend Contract"
					icon={() => <FontAwesomeIcon icon={faEdit} size="9x" />}
					width="80%"
					onClick={useSupervisorAccess(onChange, 'amend_contract')}
				/>
			</MenuPage>
		</>
	);
};

export default Menu;
